import React from "react";
import "../../styles/About/OurTeam.scss";
import { Container, Row, Col, Card } from "react-bootstrap";
import { FaFacebookF, FaTwitter, FaLinkedinIn } from "react-icons/fa";
import teamMemberImage from "../../assets/images/ourTeamMemberImage.png";
const OurTeam = () => {
  return (
    <Container fluid className="our-team-container">
      <Container>
        <div className="title text-center our-team-title">Our Team</div>
        <Row className="g-4 justify-content-around">
          <Col md={3} className="p-0 d-block m-auto">
            <Card>
              <Card.Img
                variant="top"
                src={teamMemberImage}
                className="img-fluid"
                alt=""
              />
              <Card.Body>
                <Card.Title className="our-team-member-title">
                  Rafeed Khan
                </Card.Title>
                <Card.Text className="our-team-member-designation text-center">
                  Executive Chairman
                </Card.Text>
              </Card.Body>
            </Card>
            <div className="social-icons text-center">
              <span className="social-icon">
                <FaFacebookF />
              </span>
              <span className="social-icon">
                <FaTwitter />
              </span>
              <span className="social-icon">
                <FaLinkedinIn />
              </span>
            </div>
          </Col>
          <Col md={3} className="p-0 d-block m-auto">
            <Card>
              <Card.Img
                variant="top"
                src={teamMemberImage}
                className="img-fluid"
                alt=""
              />
              <Card.Body>
                <Card.Title className="our-team-member-title">
                  Michael Wong
                </Card.Title>
                <Card.Text className="our-team-member-designation text-center">
                  Director
                </Card.Text>
              </Card.Body>
            </Card>
            <div className="social-icons text-center">
              <span className="social-icon">
                <FaFacebookF />
              </span>
              <span className="social-icon">
                <FaTwitter />
              </span>
              <span className="social-icon">
                <FaLinkedinIn />
              </span>
            </div>
          </Col>
          <Col md={3} className="p-0 d-block m-auto">
            <Card>
              <Card.Img
                variant="top"
                src={teamMemberImage}
                className="img-fluid"
                alt=""
              />
              <Card.Body>
                <Card.Title className="our-team-member-title">
                  Bahjat Aman
                </Card.Title>
                <Card.Text className="our-team-member-designation text-center">
                  Managing DIrector
                </Card.Text>
              </Card.Body>
            </Card>
            <div className="social-icons text-center">
              <span className="social-icon">
                <FaFacebookF />
              </span>
              <span className="social-icon">
                <FaTwitter />
              </span>
              <span className="social-icon">
                <FaLinkedinIn />
              </span>
            </div>
          </Col>
        </Row>
        {/* 2nd Row */}
        <Row
          className="g-4"
          style={{ marginTop: "35px", marginBottom: "69px" }}
        >
          <Col md={3}></Col>
          <Col md={2} className="p-0">
            <Card>
              <Card.Img
                variant="top"
                src={teamMemberImage}
                className="img-fluid"
                alt=""
              />
              <Card.Body>
                <Card.Title className="our-team-member-title">
                  Rafeed Khan
                </Card.Title>
                <Card.Text className="our-team-member-designation text-center">
                  Executive Chairman
                </Card.Text>
              </Card.Body>
            </Card>
            <div className="social-icons text-center">
              <span className="social-icon">
                <FaFacebookF />
              </span>
              <span className="social-icon">
                <FaTwitter />
              </span>
              <span className="social-icon">
                <FaLinkedinIn />
              </span>
            </div>
          </Col>
          <Col md={2}></Col>
          <Col md={2} className="p-0">
            <Card>
              <Card.Img
                variant="top"
                src={teamMemberImage}
                className="img-fluid"
                alt=""
              />
              <Card.Body>
                <Card.Title className="our-team-member-title">
                  Uttam Singh
                </Card.Title>
                <Card.Text className="our-team-member-designation text-center">
                  Director
                </Card.Text>
              </Card.Body>
            </Card>
            <div className="social-icons text-center">
              <span className="social-icon">
                <FaFacebookF />
              </span>
              <span className="social-icon">
                <FaTwitter />
              </span>
              <span className="social-icon">
                <FaLinkedinIn />
              </span>
            </div>
          </Col>
        </Row>
        {/* 3rd Row */}
        <Row xs={1} md={6} className="g-4">
          <Col>
            <Card>
              <Card.Img
                variant="top"
                src={teamMemberImage}
                className="img-fluid"
                alt=""
              />
              <Card.Body>
                <Card.Title className="our-team-member-title employee-title">
                  Rafeed Khan
                </Card.Title>
                <Card.Text className="our-team-member-designation text-center">
                  Executive Chairman
                </Card.Text>
              </Card.Body>
            </Card>
            <div className="social-icons text-center">
              <span className="social-icon employee-social-icon">
                <FaFacebookF />
              </span>
              <span className="social-icon employee-social-icon">
                <FaTwitter />
              </span>
              <span className="social-icon employee-social-icon">
                <FaLinkedinIn />
              </span>
            </div>
          </Col>
          <Col>
            <Card>
              <Card.Img
                variant="top"
                src={teamMemberImage}
                className="img-fluid"
                alt=""
              />
              <Card.Body>
                <Card.Title className="our-team-member-title employee-title">
                  Michael Wong
                </Card.Title>
                <Card.Text className="our-team-member-designation text-center">
                  Director
                </Card.Text>
              </Card.Body>
            </Card>
            <div className="social-icons text-center">
              <span className="social-icon employee-social-icon">
                <FaFacebookF />
              </span>
              <span className="social-icon employee-social-icon">
                <FaTwitter />
              </span>
              <span className="social-icon employee-social-icon">
                <FaLinkedinIn />
              </span>
            </div>
          </Col>
          <Col>
            <Card>
              <Card.Img
                variant="top"
                src={teamMemberImage}
                className="img-fluid"
                alt=""
              />
              <Card.Body>
                <Card.Title className="our-team-member-title employee-title">
                  Bahjat Aman
                </Card.Title>
                <Card.Text className="our-team-member-designation text-center">
                  Managing DIrector
                </Card.Text>
              </Card.Body>
            </Card>
            <div className="social-icons text-center">
              <span className="social-icon employee-social-icon">
                <FaFacebookF />
              </span>
              <span className="social-icon employee-social-icon">
                <FaTwitter />
              </span>
              <span className="social-icon employee-social-icon">
                <FaLinkedinIn />
              </span>
            </div>
          </Col>
          <Col>
            <Card>
              <Card.Img
                variant="top"
                src={teamMemberImage}
                className="img-fluid"
                alt=""
              />
              <Card.Body>
                <Card.Title className="our-team-member-title employee-title">
                  Rafeed Khan
                </Card.Title>
                <Card.Text className="our-team-member-designation text-center">
                  Executive Chairman
                </Card.Text>
              </Card.Body>
            </Card>
            <div className="social-icons text-center">
              <span className="social-icon employee-social-icon">
                <FaFacebookF />
              </span>
              <span className="social-icon employee-social-icon">
                <FaTwitter />
              </span>
              <span className="social-icon employee-social-icon">
                <FaLinkedinIn />
              </span>
            </div>
          </Col>
          <Col>
            <Card>
              <Card.Img
                variant="top"
                src={teamMemberImage}
                className="img-fluid"
                alt=""
              />
              <Card.Body>
                <Card.Title className="our-team-member-title employee-title">
                  Michael Wong
                </Card.Title>
                <Card.Text className="our-team-member-designation text-center">
                  Director
                </Card.Text>
              </Card.Body>
            </Card>
            <div className="social-icons text-center">
              <span className="social-icon employee-social-icon">
                <FaFacebookF />
              </span>
              <span className="social-icon employee-social-icon">
                <FaTwitter />
              </span>
              <span className="social-icon employee-social-icon">
                <FaLinkedinIn />
              </span>
            </div>
          </Col>
          <Col>
            <Card>
              <Card.Img
                variant="top"
                src={teamMemberImage}
                className="img-fluid"
                alt=""
              />
              <Card.Body>
                <Card.Title className="our-team-member-title employee-title">
                  Bahjat Aman
                </Card.Title>
                <Card.Text className="our-team-member-designation text-center">
                  Managing DIrector
                </Card.Text>
              </Card.Body>
            </Card>
            <div className="social-icons text-center">
              <span className="social-icon employee-social-icon">
                <FaFacebookF />
              </span>
              <span className="social-icon employee-social-icon">
                <FaTwitter />
              </span>
              <span className="social-icon employee-social-icon">
                <FaLinkedinIn />
              </span>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default OurTeam;
